<div fxLayout="row column" fxFlex="100" fxLayoutAlign="center center">
  <button p-button type="submit" class="p-button chronos-cockpit">
    <a [href]="url" target="_blank" class="btn-block" type="submit">
      {{ linkText }}
    </a>
  </button>
</div>
